import React from 'react';
import styles from './Avatar.module.css';

/** "Edward Gunning" -> "EG", "cher" -> "C", "" -> "V" (the Velox mark). */
export function initialsFromName(name) {
  const cleaned = String(name || '').trim();
  if (!cleaned) return 'V';

  const parts = cleaned.split(/\s+/).filter(Boolean);
  const first = (parts[0] || '').charAt(0);
  const last = parts.length > 1 ? (parts[parts.length - 1] || '').charAt(0) : '';
  const initials = (first + last).toUpperCase();

  return initials || 'V';
}

/**
 * The user's face wherever it appears: sidebar, top bar and account hub.
 *
 * Initials are the designed state rather than a placeholder, so an account
 * with no picture never looks unfinished. The letters scale with the avatar so
 * a 28px nav avatar and a 96px hub avatar stay optically consistent.
 */
export default function Avatar({ name, src, size = 40, className, ring = true }) {
  const initials = initialsFromName(name);
  const label = name ? `${name}'s profile picture` : 'Profile picture';

  const style = {
    width: size,
    height: size,
    // Letters read small inside a circle, so they take a larger share of it as
    // the avatar shrinks.
    fontSize: `${Math.max(11, Math.round(size * (size < 40 ? 0.42 : 0.36)))}px`,
  };

  return (
    <span
      className={[styles.avatar, ring ? styles.ring : '', className].filter(Boolean).join(' ')}
      style={style}
      data-has-image={src ? 'true' : 'false'}
    >
      {src ? (
        <img className={styles.image} src={src} alt={label} width={size} height={size} />
      ) : (
        <span className={styles.initials} aria-hidden="true">
          {initials}
        </span>
      )}
    </span>
  );
}
